// extracted by mini-css-extract-plugin
export var brand = "_1p-8";
export var compact = "_1p-5";
export var extraSmall = "_1p-6";
export var icon = "_1p-0";
export var large = "_1p-3";
export var light = "_1p-1";
export var medium = "_1p-4";
export var outline = "_1p-a";
export var primaryDark = "_1p-9";
export var primaryLight = "_1p-7";
export var primaryModern = "_1p-b";
export var success = "_1p-2";